import type { PropsWithChildren } from 'react'
import React from 'react'

import ErrorIcon from '../../../assets/icons/gtk-cancel.png'
import { Button } from '../Button'
import { Window } from '../Window'
import type { WindowProps } from '../Window/Window'

export interface ErrorProps extends WindowProps {
  title: string
  iconSize?: number
  onClose?: () => void
  onConfirm?: () => void
  confirmText?: string
}

export const Error = ({
  onClose = () => {},
  title,
  children,
  iconSize = 48,
  confirmText = 'Ok',
  onConfirm = () => {},
  ...windowProps
}: PropsWithChildren<ErrorProps>) => {
  return (
    <Window title={title} onClose={onClose} {...windowProps} showClose>
      <div style={{ textAlign: 'center' }}>
        <div style={{ display: 'flex' }}>
          <img src={ErrorIcon} alt="Error" width={iconSize} height={iconSize} />
          {children}
        </div>
        <Button onClick={onConfirm}>{confirmText}</Button>
      </div>
    </Window>
  )
}
